import { NexusService } from 'global-apis/nexus-service'
import { useMutation, useQuery } from '@tanstack/react-query'
import {
  ListRecurringBillableItemsResponse,
  RecurringBillableItem,
} from '@nxcr-org/web-api-interface/lib/billing_service_pb'

export function useCustomerBilling(customerId: string, subscriptionId: string) {
  const subscriptionAmountMutation = useMutation({
    mutationFn: ({
      recurringBillableItem,
      amount,
    }: {
      recurringBillableItem: RecurringBillableItem.AsObject
      amount: number
    }) => {
      const item = new RecurringBillableItem()
      item.setAmount(amount)
      item.setId(recurringBillableItem.id)
      item.setProductType(recurringBillableItem.productType)
      return NexusService.updateRecurringBillableItems(
        customerId,
        subscriptionId,
        [item]
      )
    },
  })

  function useRecurringBillableItems() {
    const {
      data: recurringBillableItems,
      refetch,
    } = useQuery({
      queryKey: ['/recurringBillableItems', customerId, subscriptionId],
      queryFn: () =>
        NexusService.listRecurringBillableItems(
          customerId,
          subscriptionId
        ),
      placeholderData: {} as ListRecurringBillableItemsResponse.AsObject,
      enabled: !!subscriptionId,
    }
    )

    return {
      recurringBillableItems:
        recurringBillableItems?.recurringBillableItemsList,
      refetchBillableItems: refetch,
    }
  }

  function deleteMileagePackage(
    recurringBillableItems: RecurringBillableItem.AsObject[]
  ) {
    const {
      data: success,
      refetch,
    } = useQuery({
      queryKey: ['/deleteMileagePackage'],
      queryFn: () =>
        NexusService.removeMileageRecurringBillableItem(
          customerId,
          subscriptionId,
          getMileagePackageId(recurringBillableItems)
        ).then((res) => {
          return res
        }),

        refetchOnWindowFocus: false,
        enabled: false,
      }
    )

    function getMileagePackageId(
      recurringBillableItems: RecurringBillableItem.AsObject[]
    ) {
      const mileageRecurringBillableItems = recurringBillableItems.find(
        (rbi) => rbi.productType === 23
      )
      return mileageRecurringBillableItems.id
    }

    return {
      success,
      doDeleteMileagePackage: refetch,
    }
  }

  return {
    useRecurringBillableItems,
    doUpdateSubscriptionAmount: subscriptionAmountMutation.mutateAsync,
    isSavingSubscription: subscriptionAmountMutation.isPending,
    deleteMileagePackage,
  }
}
